import { Component, OnInit ,ChangeDetectorRef, EventEmitter, Output, OnDestroy} from '@angular/core';
import { CallCenterService } from 'src/app/services/call-center.service';
import { CommonService} from 'src/app/services/common.service'
import{ CommonMethods } from 'src/app/shared/CommonMethods'; 
import { Subscription } from 'rxjs';
import { AskApolloService } from 'src/app/services/ask-apollo.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageServiceService } from 'src/app/services/message-service.service';
import { AttachSession } from 'protractor/built/driverProviders';

@Component({
  selector: 'app-cancel-appointment',
  templateUrl: './cancel-appointment.component.html',
  styleUrls: ['./cancel-appointment.component.scss']
})
export class CancelAppointmentComponent implements OnInit,OnDestroy {

  leadId;
  localAppointmentId;
  isNewUser;
  callType
  callerStatusAutoId;
  callerId;
  appointmentDetails=[];
  selectedCallStatusId;
  selectedCallStatusName;
  statusRemarks='';
  isCancelConfirmed: boolean = true;
  initialFlag :boolean = true;
  rescheduleAppointmentForm: FormGroup;
  @Output() cancelDone: EventEmitter<any> = new EventEmitter<any>();
  selectedCancelApptDetails$ : Subscription;

  constructor(private callCenterService: CallCenterService,
    private messageService: MessageServiceService,
    private askApolloService: AskApolloService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private commonService: CommonService,) 
  { 
    this.selectedCancelApptDetails$ = this.callCenterService.selectedCancelApptDetails.subscribe(value => {
      debugger;
      this.leadId = value.LeadId;
      this.isNewUser = value.IsNewUser;
      this.callType = value.CallTypeId;
      this.callerStatusAutoId = value.CallerStatusAutoId?value.CallerStatusAutoId:0;
      this.callerId = value.CallerId;
      this.appointmentDetails = value.RescheduleDetails;
      this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
      this.localAppointmentId = this.appointmentDetails["id"];
    });
  }

  ngOnInit() {
    this.getAppointmentDetails();
  }
  
  ngOnDestroy(): void {
    this.selectedCancelApptDetails$.unsubscribe();
  }

  getAppointmentDetails(){
    
  }
  
  loadingFlag: boolean = false;
  CancelAppointment(){
    debugger;
    console.log("data", this.appointmentDetails)
    if (this.statusRemarks != "") {
      debugger;

      let payload = {
        "askApolloAppointmentId": +this.appointmentDetails['askApolloAppointmentId'],
        "localAppointmentId": this.localAppointmentId,
        "appointmentAutoId": this.appointmentDetails['appointmentAutoId'] ? +this.appointmentDetails['appointmentAutoId'] : -1,
        "cancelledBy": 0,
        "cancelRemarks": this.statusRemarks,
        "cancelledIp": "",
        "callerAutoId": +this.callerStatusAutoId?this.callerStatusAutoId:0,
        "CallerId": this.callerId,
        "callStatusId": +this.selectedCallStatusId,
        "cityId": +this.appointmentDetails['cityId'],
        "HospitalId": +this.appointmentDetails['hospitalId'],
        "SpecialtyId": +this.appointmentDetails['specialtyId'],
        "doctorId": +this.appointmentDetails['doctorId'],
        "AppointmentDate": this.appointmentDetails['appointmentDate'],
        "statusRemarks": this.statusRemarks,
        "isActivityLead": localStorage.getItem("IsActivityLead") == 'true' ? true : false,

      }
      this.loadingFlag = true;
      this.askApolloService.CancelAppointment(payload)
        .subscribe((res: any) => {
          debugger;
          console.log("Cancel:", res);
          if (res.statusCode > 0) {
            this.cancelDone.emit();
            this.messageService.showSuccess(res.statusMessage);
            this.callCenterService.afterCompleteOperationKnowTheStatus({
              "callStatusId": this.selectedCallStatusId,
              "callStatusName": this.selectedCallStatusName,
              "isOperationDone": true,
              "statusMessage": "Appointment Cancelled Successfully."
            });
          } else {
            this.messageService.showErrorMessage(res.statusMessage);
          }
          this.loadingFlag = false;
        }, error => {
          debugger;
          this.messageService.showErrorMessage("Unable to cancel appointment, An error occur while cancelling appointment.");
          this.loadingFlag = false;
        })
    }else{
      this.messageService.showErrorMessage("Required Call Remarks");
    }
  }

}
